import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";
import { useState } from "react";

import NavigationBreadcrumbs from "../../common/navigation/NavigationBreadcrumbs";
import SideNavigationMenu from "../../common/navigation/SideNavigationMenu";
import Paths from "../../common/paths/paths";
import EditCatalogForm from "../../components/EditCatalogForm/EditCatalogForm";

const breadcrumbs = {
    items: [
        { text: Paths.Admin.name, href: Paths.Admin.url },
        { text: Paths.manageCatalog.name, href: Paths.manageCatalog.url },
        { text: Paths.editCatalog.name, href: Paths.editCatalog.url },
    ],
};

const EditCatalogPage = () => {
    const [navigationOpen, setNavigationOpen] = useState(false);

    return (
        <AppLayout
            content={<EditCatalogForm />}
            contentType={"form"}
            breadcrumbs={<NavigationBreadcrumbs items={breadcrumbs.items} />}
            navigation={<SideNavigationMenu />}
            navigationOpen={navigationOpen}
            onNavigationChange={(event: any) => setNavigationOpen(event.detail.open)}
        />
    );
};

export default EditCatalogPage;
